import { create } from 'zustand';
import { templateService, type GetTemplateDataResponse, type TemplateData, type TemplateSingleData } from '../services/templateService';

interface TemplateState {
  saveTemplate: (templateData: TemplateData) => Promise<any>;
  getListTemplates: (params?: { page?: number; page_size?: number; search?: string }) => Promise<any>;
  saveSingleTemplate: (templateData: TemplateSingleData) => Promise<any>;
  updateTemplate: (templateId: string, templateData: Omit<TemplateData, 'file'>) => Promise<any>;
  deleteTemplate: (templateId: string | string[]) => Promise<any>;
  getTemplate: (templateId: string) => Promise<{ success: boolean; message: string, data?: GetTemplateDataResponse }>;
}

export const useTemplateStore = create<TemplateState>(() => ({

  saveTemplate: async (templateData: TemplateData) => {
    try {
      const result = await templateService.saveTemplate(templateData);
      return result;
    } catch (error) {
      return false;
    }
  },

  getListTemplates: async (params?: { page?: number; page_size?: number; search?: string }) => {
    try {
      const response = await templateService.getTemplates(params);
      return response;
    } catch (error) {
      console.error('Error fetching Templates:', error);
      throw error;
    }
  },

  saveSingleTemplate: async (templateData: TemplateSingleData) => {
    try {
      const result = await templateService.saveSingleTemplate(templateData);
      return result;
    } catch (error) {
      return false;
    }
  },

  updateTemplate: async (templateId: string, templateData: Omit<TemplateData, 'file'>) => {
    try {
      const result = await templateService.updateTemplate(templateId, templateData);
      return result;
    } catch (error) {
      return false;
    }
  },

  deleteTemplate: async (templateId: string | string[]) => {
    if (Array.isArray(templateId)) {
      const result = await templateService.deleteTemplates(templateId);
      return result;
    }
    try {
      const result = await templateService.deleteTemplate(templateId);
      return result;
    } catch (error) {
      return false;
    }
  },

  getTemplate: async (templateId: string): Promise<{ success: boolean; message: string, data?: GetTemplateDataResponse }> => {
    try {
      const result = await templateService.getTemplate(templateId);
      return result;
    } catch (error) {
      return {
        success: false,
        message: 'Error al obtener template',
      };
    }
  }
}));